import { useQuery } from '@tanstack/react-query'
import {
  getOperatorPerformance,
  GetOperatorPerformanceParams,
} from '../api/application-queue-operator-performance'
import { OperatorPerformanceResponse } from '../types/PerformanceDashboard'

export function useOperatorPerformance(params: GetOperatorPerformanceParams) {
  return useQuery<OperatorPerformanceResponse>({
    queryKey: ['operator-performance', params.timezone, params.effectiveDate],
    queryFn: () => getOperatorPerformance(params),
    enabled: !!params.timezone && !!params.effectiveDate,
  })
}
